import Vue from 'vue';
import MaskedInput from 'vue-text-mask';

Vue.component('masked-input', MaskedInput);
